
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { setPay, setInviteLogin } from '@/api/gcash/account'
import { getBnakList } from '@/api/universal'
import { getProductList } from '@/api/product/product'

@Component({
  name: 'onePay',
  components: {},
})
export default class extends Vue {
  private loading: boolean = false
  private google_code: any = ''
  // pay_bank
  private payBankForm: any = {
    bank_name: '',
    bank_code: '',
    dst_accno: '',
    dst_accname: '',
    amount: '',
    msisdns: [],
  }

  private rules: any = {
    msisdns: [
      {
        required: true,
        message: 'Please select online account',
        trigger: 'change',
      },
    ],
    to_gcash: [
      {
        required: true,
        message: 'Please enter transfer to account',
        trigger: 'blur',
      },
    ],
    amount: [
      {
        required: true,
        message: 'Please enter the amount transferred',
        trigger: 'blur',
      },
    ],
    remark: [
      { required: true, message: 'Please enter remarks', trigger: 'blur' },
    ],
    to_msisdn: [
      { required: true, message: 'Please enter to phone', trigger: 'blur' },
    ],
    bank_name: [
      { required: true, message: 'Please select bank name', trigger: 'change' },
    ],
    bank_code: [
      { required: true, message: 'Please enter bank code', trigger: 'blur' },
    ],
    dst_accno: [
      {
        required: true,
        message: 'Please enter bank accounts',
        trigger: 'blur',
      },
    ],
    dst_accname: [
      { required: true, message: 'Please enter holder name', trigger: 'blur' },
    ],
  }

  // 获取Gcash产品明细
  private bankList: any = []
  private async getList() {
    try {
      await setInviteLogin({
        action: 'product_bank',
        data: {
          code: 'GCash',
        },
      }).then((res: any) => {
        this.bankList = res.data
      })
    } catch (e) {}
  }

  // 批量转账在线GCash 账户列表接口
  private gcashList: any = []
  private async getUserList() {
    try {
      await setInviteLogin({
        action: 'get_transfer_Account',
        // data: {
        //   code: 'GCash',
        // },
      }).then((res: any) => {
        this.gcashList = res.data
      })
    } catch (e) {}
  }

  private changeBank(val: any) {
    let bankCode = this.bankList.filter((item) => {
      return item.bank_name === val
    })
    this.payBankForm.bank_code = bankCode[0].bank_code
  }

  private change() {
    this.google_code = ''
  }

  private back() {
    this.payBankForm = {
      bank_name: '',
      bank_code: '',
      dst_accno: '',
      dst_accname: '',
      amount: '',
      msisdns: [],
    }
    this.google_code = ''
    this.$emit('close')
  }

  public flag: boolean = false
  // 按钮只触发一次
  public flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 1000)
  }

  private async payBank() {
    ;(this.$refs.payBankForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.flag = true
          let data: any = {
            action: 'batch_transfer_bank',
            data: {
              msisdns: this.payBankForm.msisdns.join(','),
              dst_accno: this.payBankForm.dst_accno,
              dst_accname: this.payBankForm.dst_accname,
              bank_name: this.payBankForm.bank_name,
              bank_code: this.payBankForm.bank_code,
              google_code: this.google_code,
            },
          }
          await setInviteLogin(data).then((res: any) => {
            // this.$message({
            //   message: 'Successful transfer!',
            //   type: 'success',
            // })
            // this.loading = false
            // this.back()
            // this.flagStr()
            if (res.result === 'false') {
              this.$message({
                message: `${res.message}`,
                type: 'error',
              })
            } else {
              this.$message({
                message: 'Successful transfer!',
                type: 'success',
              })
              this.back()
            }
            this.loading = false
            this.flagStr()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  private selectMsisdn(val) {
    if (!val.includes('all') && val.length === this.gcashList.length) {
      this.payBankForm.msisdns.unshift('all')
    } else if (val.includes('all') && val.length - 1 < this.gcashList.length) {
      this.payBankForm.msisdns = this.payBankForm.msisdns.filter((item) => {
        return item !== 'all'
      })
    }
    setTimeout(() => {
      this.getSum()
    }, 200)
  }
  private getSum() {
    this.payBankForm.amount = ''
    let list = []
    let sum = 0
    // val.splice(val.indexOf('all'), 1)
    list = this.payBankForm.msisdns.map((item: any) =>
      this.gcashList.find((i: any) => i.account_no === item)
    )
    list.map((item: any) => {
      if (item) {
        sum += Number(item.balance)
      }
    })
    this.payBankForm.amount = sum
  }
  selectAll() {
    if (this.payBankForm.msisdns.length < this.gcashList.length) {
      this.payBankForm.msisdns = []
      this.gcashList.map((item) => {
        this.payBankForm.msisdns.push(item.account_no)
      })
      this.payBankForm.msisdns.unshift('all')
    } else {
      this.payBankForm.msisdns = []
    }
  }
  removeTag(val) {
    if (val === 'all') {
      this.payBankForm.msisdns = []
    }
  }

  private async init() {
    await this.getList()
    await this.getUserList()
    // let el: any = this.$refs['payBankForm']
    // this.$nextTick(() => {
    //   el.resetFields()
    // })
  }

  mounted() {
    this.init()
  }
}
